import { Button, Image, useIsDesktop, useVisibilityState } from '@lbcamden/lib-react';
import { FunctionComponent, ReactNode } from 'react';

import { ClutterScaleDialog, ClutterScaleTabs, ImageContainer } from './ClutterScale.styled';

type Props = {
  buttonLabel?: ReactNode;
};

const title = 'Clutter scale';

export const ClutterScale: FunctionComponent<Props> = ({ buttonLabel = title }) => {
  const isDesktop = useIsDesktop();

  const { show, hide, visible } = useVisibilityState();

  const renderImage = (imageName: string) => (
    <ImageContainer>
      <Image src={`/images/${imageName}${isDesktop ? '' : '-mob'}.png`} />
    </ImageContainer>
  );

  return (
    <>
      <Button
        css={{ alignSelf: 'flex-start', border: 0, textDecoration: 'underline' }}
        $variant="link"
        $color="primary"
        onClick={show}
      >
        {buttonLabel}
      </Button>
      <ClutterScaleDialog open={visible} onClose={hide} title={title} accessibleInfo={{ title }}>
        <ClutterScaleTabs
          tabs={[
            {
              label: 'Kitchen',
              value: 'kitchen',
              content: renderImage('clutter-scale-kitchen'),
            },
            {
              label: 'Bedroom',
              value: 'bedroom',
              content: renderImage('clutter-scale-bedroom'),
            },
            {
              label: 'Living room',
              value: 'livingRoom',
              content: renderImage('clutter-scale-living-room'),
            },
          ]}
        />
      </ClutterScaleDialog>
    </>
  );
};
